<template>
  <div class="wrapper">
    <van-nav-bar
      fixed
      title="企业自荐"
      left-arrow
      class="top-h"
      @click-left="back"
    />
    <div class="content-wrapper mb-4" style="background-color: #f7f8fa">
      <div class="invert-wrapper">
        <ClueEntry :iscomponent="true"></ClueEntry>
      </div>
    </div>
  </div>
</template>
<script>
import ClueEntry from "../InvestMent/children/ClueEntry.vue";
export default {
  components: {
    ClueEntry,
  },
  name: "zijian",
  data() {
    return {};
  },
  methods: {
    back(){
      try{
        WeixinJSBridge.invoke('closeWindow', {}, function (res) { })
      }catch(e){}
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.wrapper {
  width: 100%;
}
.content-wrapper {
  width: 100%;
  margin-top: 46px;
  height: calc(100vh - 46px);
  position: relative;
  .invert-wrapper {
    width: 90%;
    margin: 0 auto;
    .active {
      background-color: rgb(247, 248, 250);
    }
    .wrapper {
      display: flex;
      font-size: 10px;
      justify-content: space-between;
      & > span {
        display: inline-block;
      }
    }
  }
}
.top-h{
  z-index: 99;
}
</style>
